<template>
  <div class="checkDetails2">
    <div class="crumbs">
      <crumbs></crumbs>
    </div>
    <div class="guarantee" v-if="info">
      <div class="guerLeft">
        <div class="guerImgBox">
          <img :src="status[info.status].url" alt="" />
          <div>
            <i class="iconfont" :class="status[info.status].icon"></i>
            {{ info.statusTxt }}
          </div>
        </div>
      </div>
      <div class="guerRight">
        <div class="guerRightTop">
          <p>批单号：{{ info.correct_num ? info.correct_num : "暂无" }}</p>
          <p class="premium">
            保费：<span>{{ info.policy_money }}</span>
          </p>
        </div>
        <div class="guerRightMiddle">
          <p>流水号：{{ info.num_id }}</p>
          <p>保险公司：{{ info.companyName }}</p>
          <p>批改时间：{{ info.c_time }}</p>
          <p>产品名称：{{ info.productName }}</p>
          <p>保障期限：{{ info.s_time }} - {{ info.e_time }}</p>
          <p>提交人：{{ info.adminName }}</p>
          <p>财务余额：共 {{ info.balance.balance }} 元，锁定：{{ info.balance.lock }} 元</p>
        </div>
      </div>
    </div>
    <div class="contentBox">
      <div class="changePaybox">
        <pay
          :id="changeId"
          :type="1"
          :numId="info.num_id"
          v-if="info.num_id"
        ></pay>
      </div>
    </div>
  </div>
</template>
<script>
import { getCorrection } from "@/api/check";
import pay from "@/components/common/pay";
import download from "@/utils/download";
import crumbs from "@/components/common/crumbs";
export default {
  name: "guaDdetails",
  components: {
    pay,
    crumbs
  },
  data() {
    return {
      status: [],
      changeId: "",
      info: "", //订单详情
      fileAttay: []
    };
  },
  created() {
    this.status = this.$store.state.orderStatus;
    this.changeId = this.$route.query.changeId;
    this.getCorrection(); //获取订单详情
  },
  methods: {
    //获取批单详情
    getCorrection() {
      let that = this;
      getCorrection({ changeId: this.changeId })
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.info = res.data;
            // 设置title
            document.title = "支付--" + res.data.applicationName;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 下载
    down(downurl) {
      download(downurl);
    }
  }
};
</script>
<style lang="scss">
.checkDetails2 {
  padding: 0 !important;
  margin-top: 15px !important;
  background: #f4f5f7 !important;
  box-shadow: none !important;
  & > .crumbs {
    margin: 0 8px;
  }
  .guarantee {
    padding: 24px 40px 40px 24px;
    background: #ffffff
      linear-gradient(
        150deg,
        #ffffff 0%,
        rgba(245, 248, 251, 0.76) 100%,
        #64dfff 100%
      );
    box-shadow: 0px 2px 4px 0px rgba(4, 46, 111, 0.11);
    border-radius: 9px 10px 5px 5px;
    margin: 15px 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    overflow: hidden;
    .guerLeft {
      width: 72px;
      height: 72px;
      margin-right: 30px;
      .guerImgBox {
        position: relative;
        top: -24px;
        height: 100%;
        img {
          position: absolute;
          top: -15px;
          left: -16px;
        }
        & > div {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          color: #fff;
          font-size: 14px;
          font-weight: 500;
          i {
            font-size: 25px;
            font-weight: 400;
            margin-top: 15px;
          }
        }
      }
    }
    .guerRight {
      width: calc(100% - 87px);
      .guerRightTop {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 20px;
        font-weight: 500;
        color: #000000;
        line-height: 28px;
        margin-bottom: 20px;
        p {
          margin: 0;
        }
        .premium {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
          line-height: 20px;
          span {
            font-size: 24px;
            color: #f76a37;
          }
        }
      }
      .guerRightMiddle {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        & > p {
          width: 33.33%;
          font-size: 14px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          line-height: 22px;
          margin: 0;
        }
      }
      .guerRightBottom {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 30px;
        p {
          margin: 0;
          font-size: 14px;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.85);
          border-radius: 15px 0px 15px 0px;
          background: #2d8aee;
          padding: 2px 12px;
          margin-right: 20px;
        }
        span {
          font-weight: 300;
          color: rgba(0, 0, 0, 0.85);
        }
      }
    }
  }
  & > .contentBox {
    background: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(4, 46, 111, 0.08);
    & > .changePaybox {
      padding: 50px 16px;
    }
  }
}
</style>
